module.exports = __webpack_public_path__ + "static/media/108c2.d1140069.jpg";